import React from 'react'
import PropTypes from 'prop-types'

import ItemAddedInfo from './ItemAddedInfo'
import ItemAddedCart from './ItemAddedCart'
import PlatinumSubscription from '../PlatinumSubscription'
import { Column, Columns, PrimaryMessage, MessageBody } from '../../../bulma'
import { Container } from '../../../core'
import { CheckIcon } from '../../../core/icons'

function ItemAddedContainer(props) {
  const {
    item, order, orderSubscriptions, platinumSubscription, checkoutStep, ...rest
  } = props

  return (
    <Container>
      <PrimaryMessage className="has-text-centered is-medium">
        <MessageBody className="has-text-primary">
          <CheckIcon />
          Item added to cart
        </MessageBody>
      </PrimaryMessage>
      <Columns>
        <Column size="two-thirds">
          <ItemAddedInfo
            item={item}
            product={item.product}
          />
        </Column>
        <Column size="one-third">
          <ItemAddedCart
            order={order}
          />
          <PlatinumSubscription
            order={order}
            orderSubscriptions={orderSubscriptions}
            platinumSubscription={platinumSubscription}
            checkoutStep="itemAdded"
          />
        </Column>
      </Columns>
    </Container>
  )
}

ItemAddedContainer.defaultProps = {
  item: {},
  order: {},
  orderSubscriptions: [],
  platinumSubscription: {},
}

ItemAddedContainer.propTypes = {
  // Item added to cart
  item: PropTypes.object,
  // The order being placed
  order: PropTypes.object,
  // The subscriptions on the order
  orderSubscriptions: PropTypes.array,
  // Platinum subscription plan
  platinumSubscription: PropTypes.object,
}

export default ItemAddedContainer
